module.exports = __webpack_public_path__ + "img/micronesia-(federated-states-of).f71bc4b8.svg";